// extracted by mini-css-extract-plugin
export default {"container":"InDevelopment_container__9XXXC","namePage":"InDevelopment_namePage__Geaj+","message":"InDevelopment_message__BNSzo"};